import { memo } from 'react';

import { cn } from '../../lib/styles';
import { TableListItemProps } from './TableList.types';
import { ChildPositionProvider } from '@page/core/hooks/dom/useChildPosition';
import { Divider } from '../Divider';

const TableListItemBase = ({
  label,
  variant = 'wrap',
  children,
  className,
  containerClassName,
  dividerClassName,
  labelClassName,
  valueContainerClassName,
  showDivider = true,
  ...rest
}: TableListItemProps) => {
  return (
    <div className={cn('flex flex-col', variant === 'responsive' && '@container', containerClassName)} {...rest}>
      <div
        className={cn(
          'table-list-item flex items-start gap-x-5',
          {
            'flex-wrap': variant === 'wrap',
            'flex-col gap-x-0': variant === 'column',
            'flex-col @[800px]:flex-row': variant === 'responsive',
          },
          className,
        )}
      >
        <div
          data-slot="label"
          className={cn(
            'font-body-md text-text-primary font-semibold',
            {
              'h-0': !label,
              'pt-4': label,
              'min-w-[280px]': variant === 'wrap',
              'min-w-[120px] max-w-[120px]': variant === 'compact-row',
              'pb-1': variant === 'column',
              '@[800px]:min-w-[280px]': variant === 'responsive',
            },
            labelClassName,
          )}
        >
          {label}
        </div>

        <div data-slot="values" className={cn('flex-1 py-1', valueContainerClassName)}>
          <ChildPositionProvider>{children}</ChildPositionProvider>
        </div>
      </div>

      {showDivider && <Divider className={dividerClassName} />}
    </div>
  );
};

export const TableListItem = memo(TableListItemBase);
